import {
	apiService,
	getController,
	type HpRequestOptional,
} from '@/services/service'

const url = 'buildings'

export const buildingService = {
	...getController<Api.Building>(url),
	index: (data?: HpRequestOptional) =>
		apiService.get<Api.Collection<Api.Building>>({
			url: `${url}?rel=["images"]`,
			...data,
		}),
	show: (id: number, data?: HpRequestOptional) =>
		apiService.get<Api.Building>({
			url: `${url}/${id}?rel=["address","images","propertymanager.person", "team"]`,
			...data,
		}),
	itemModuleGet: <T = unknown>(id: number, module: string) =>
		apiService.get<T>({ url: `${url}/${id}/${module}` }),
	accountsGet(id: number, role?: number) {
		return apiService.get<Api.Collection<Api.RolePermission>>({
			url:
				`${url}/${id}/persons?wu=true&pageSize=9999&sm=1&rel=["person.user"]&grouped=true&active=true&finn=user_id` +
				(role ? `&role=${role}` : ''),
		})
	},
	syncAssfinetContracts: (buildingId: number, contractIds: number) =>
		apiService.post({
			url: `${url}/${buildingId}/sync/assfinet_contracts/`,
			data: {
				contract_ids: contractIds,
			},
		}),
	listForVisibility: () =>
		apiService.get<{
			data: Array<{
				id: number
				hp_id: Api.Id
				is_hidden: boolean
				proposed_for_export: Api.BuildingExportStatus
				address: { street: string; zip: string; city: string } | null
			}>
		}>({ url: `${url}/visibility` }),
	setVisibility: (payload: { hide: number[]; show: number[] }) =>
		apiService.post<{ ok: boolean; hidden: number; shown: number }>({
			url: `${url}/visibility`,
			data: payload,
		}),
}

export default buildingService
